import type { UserManagerSettings } from 'oidc-client-ts';

const OIDC_ENV_NAMES = {
  clientId: 'KEYCLOAK_CLIENT_ID',
  authority: 'KEYCLOAK_AUTHORITY',
} as const;

function getRequiredOidcEnvVars(): { clientId: string; authority: string } {
  const clientId = import.meta.env.KEYCLOAK_CLIENT_ID;
  const authority = import.meta.env.KEYCLOAK_AUTHORITY;

  if (clientId && authority) {
    return { clientId, authority };
  }

  console.error(
    `[auth] Missing required environment variable: ${OIDC_ENV_NAMES.clientId} or ${OIDC_ENV_NAMES.authority}`,
  );
  return { clientId: '', authority: '' };
}

const oidcEnvVars = getRequiredOidcEnvVars();

export const userManagerConfig: UserManagerSettings = {
  authority: oidcEnvVars.authority,
  client_id: oidcEnvVars.clientId,
  redirect_uri: window.location.origin,
  silent_redirect_uri: `${window.location.origin}/silent-redirect.html`,
  automaticSilentRenew: false,
  silentRequestTimeoutInSeconds: 10,
  revokeTokensOnSignout: true,
};

export const keycloakConfig = {
  authority: userManagerConfig.authority,
  clientId: userManagerConfig.client_id,
} as const;
